const FRENCH_PREFIX = '/fr'

// Absolute links to our own site, as editors sometimes paste them into Contentful.
const SITE_ORIGIN_REGEX = /^https?:\/\/(www\.)?borrowell\.com(?=[/?#]|$)/

const toFrenchPath = (path: string) => (path === '/' ? FRENCH_PREFIX : `${FRENCH_PREFIX}${path}`)

/**
 * @description on a French page, rewrite a link to its French version when one is built.
 * Slugs aren't translated, so the French version of `/credit-cards` is `/fr/credit-cards`.
 * Links to pages without a French version, other sites and the web app are returned unchanged.
 * @example localizeHref('/credit-cards?ref=nav', new Set(['/fr/credit-cards'])) => '/fr/credit-cards?ref=nav'
 */
export const localizeHref = (href: string, frenchPaths: Set<string>): string => {
  const withoutOrigin = href.replace(SITE_ORIGIN_REGEX, '')
  // An absolute link to our homepage can skip the path slash (`https://borrowell.com?utm=…`).
  const relativeHref =
    withoutOrigin !== href && (withoutOrigin === '' || /^[?#]/.test(withoutOrigin))
      ? `/${withoutOrigin}`
      : withoutOrigin
  if (!relativeHref.startsWith('/') || relativeHref.startsWith('//')) return href

  const suffixIndex = relativeHref.search(/[?#]/)
  const rawPath = suffixIndex === -1 ? relativeHref : relativeHref.slice(0, suffixIndex)
  const suffix = suffixIndex === -1 ? '' : relativeHref.slice(suffixIndex)
  const path = rawPath.length > 1 ? rawPath.replace(/\/$/, '') : rawPath

  if (path === FRENCH_PREFIX || path.startsWith(`${FRENCH_PREFIX}/`)) return href

  const frenchPath = toFrenchPath(path)
  return frenchPaths.has(frenchPath) ? `${frenchPath}${suffix}` : href
}
